module.exports = __webpack_public_path__ + "b42d7c704a752a5e2f5dd85f7183ebb7.svg";